"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Colors = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _Theme = require("../../Theme");

var _Flex = require("../Flex");

var _Typography = require("../Typography");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ColorBlock = _styledComponents.default.div.withConfig({
  displayName: "Colors__ColorBlock",
  componentId: "sc-11b2fda-0"
})(["width:100%;height:75px;padding:10px;margin-bottom:20px;", ";"], _styledSystem.color);

var LabeledColorBlock = function LabeledColorBlock(_ref) {
  var name = _ref.name;
  return /*#__PURE__*/_react.default.createElement(ColorBlock, {
    bg: name
  }, /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
    flexDirection: "column"
  }, /*#__PURE__*/_react.default.createElement(_Typography.Sans, {
    color: visibleColor(name),
    size: "3"
  }, name), /*#__PURE__*/_react.default.createElement(_Typography.Sans, {
    color: visibleColor(name),
    weight: "medium",
    size: "3"
  }, _Theme.themeProps.colors[name])));
};

LabeledColorBlock.displayName = "LabeledColorBlock";
/**
 * Artsy's color palette
 */

var Colors = function Colors() {
  return /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
    flexWrap: "wrap"
  }, Object.keys(_Theme.themeProps.colors).map(function (name, key) {
    return /*#__PURE__*/_react.default.createElement(LabeledColorBlock, {
      name: name,
      key: key
    });
  }));
};

exports.Colors = Colors;
Colors.displayName = "Colors"; // http://24ways.org/2010/calculating-color-contrast/

var getContrast = function getContrast(hex) {
  var r = parseInt(hex.substr(1, 2), 16);
  var g = parseInt(hex.substr(3, 2), 16);
  var b = parseInt(hex.substr(5, 2), 16);
  var yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128 ? "black" : "white";
};

var visibleColor = function visibleColor(name) {
  return getContrast(_Theme.themeProps.colors[name]);
};